import { chalkText, chalkRect } from '../../primitives/chalk';

export async function prepareTableFillNode(env, spec) {
  const area = env.boardArea();
  const cellFontSize = env.getStyle(
    spec.table.cellFormat.size === 'title'
      ? 'titleSize'
      : spec.table.cellFormat.size === 'body'
        ? 'bodySize'
        : spec.table.cellFormat.size === 'mono'
          ? 'codeSize'
          : 'smallSize'
  );

  const cellFontFamily =
    spec.table.cellFormat.font === 'mono'
      ? 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace'
      : 'ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Arial';

  const cellWidth = Math.min(80, area.w / (spec.table.cols + 1));
  const cellHeight = cellFontSize * 2;

  const tableWidth = cellWidth * spec.table.cols;
  const tableHeight = cellHeight * spec.table.rows;

  const titleSize = spec.title ? env.getStyle('bodySize') : 0;
  const titleHeight = spec.title ? titleSize + 20 : 0;

  const gridOriginX = area.x + (area.w - tableWidth) / 2;
  const gridOriginY = area.y + (area.h - tableHeight - titleHeight) / 2 + titleHeight;

  const cells = spec.cells.map((cell) => ({
    r: cell.r,
    c: cell.c,
    x: gridOriginX + cell.c * cellWidth,
    y: gridOriginY + cell.r * cellHeight,
    value: cell.value,
  }));

  const annotations = (spec.annotations || []).map((ann) => {
    const cellIndex = spec.cells.findIndex((c) => c.r === ann.atCell.r && c.c === ann.atCell.c);
    const cell = cells.find((c) => c.r === ann.atCell.r && c.c === ann.atCell.c);
    return {
      cellIndex,
      text: ann.text,
      x: cell ? cell.x + cellWidth / 2 : gridOriginX,
      y: cell ? cell.y - 10 : gridOriginY,
    };
  });

  return {
    titleText: spec.title?.text,
    titleX: area.x + area.w / 2,
    titleY: gridOriginY - 30,
    titleSize,
    gridOrigin: { x: gridOriginX, y: gridOriginY },
    cellSize: { w: cellWidth, h: cellHeight },
    rows: spec.table.rows,
    cols: spec.table.cols,
    cellFontSize,
    cellFontFamily,
    cells,
    colLabels: spec.table.labels?.col,
    rowLabels: spec.table.labels?.row,
    intervalSec: spec.fill.intervalSec,
    highlightActive: spec.fill.highlightActiveCell,
    annotations,
  };
}

export function commitTableFillNode(packet, ctxs, anim) {
  let t = 0;

  anim.add((dt) => {
    t += dt;
    const cellIndex = Math.floor(t / packet.intervalSec);

    if (packet.titleText) {
      chalkText(
        ctxs.ink,
        packet.titleText,
        packet.titleX,
        packet.titleY,
        packet.titleSize,
        0.9,
        'sans-serif',
        'center'
      );
    }

    for (let r = 0; r < packet.rows; r++) {
      for (let c = 0; c < packet.cols; c++) {
        const x = packet.gridOrigin.x + c * packet.cellSize.w;
        const y = packet.gridOrigin.y + r * packet.cellSize.h;
        chalkRect(ctxs.ink, x, y, packet.cellSize.w, packet.cellSize.h, 0.5);
      }
    }

    if (packet.colLabels) {
      packet.colLabels.forEach((label, i) => {
        const x = packet.gridOrigin.x + i * packet.cellSize.w + packet.cellSize.w / 2;
        const y = packet.gridOrigin.y - 10;
        chalkText(
          ctxs.ink,
          label,
          x,
          y,
          packet.cellFontSize * 0.8,
          0.7,
          packet.cellFontFamily,
          'center'
        );
      });
    }

    for (let i = 0; i < Math.min(cellIndex, packet.cells.length); i++) {
      const cell = packet.cells[i];
      const alpha = packet.highlightActive && i === cellIndex - 1 ? 0.95 : 0.75;

      if (packet.highlightActive && i === cellIndex - 1) {
        chalkRect(ctxs.ink, cell.x, cell.y, packet.cellSize.w, packet.cellSize.h, 0.9);
      }

      chalkText(
        ctxs.ink,
        cell.value,
        cell.x + packet.cellSize.w / 2,
        cell.y + packet.cellSize.h / 2 + packet.cellFontSize / 3,
        packet.cellFontSize,
        alpha,
        packet.cellFontFamily,
        'center'
      );
    }

    for (const ann of packet.annotations) {
      if (cellIndex > ann.cellIndex) {
        chalkText(
          ctxs.ink,
          ann.text,
          ann.x,
          ann.y,
          packet.cellFontSize * 0.7,
          0.8,
          'sans-serif',
          'center'
        );
      }
    }

    return cellIndex < packet.cells.length;
  });
}
